"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const common = {
  activeBg: 'transparent',
  activeBoxShadow: 'none',
  bg: 'transparent',
  borderRadius: 24,
  boxShadow: 'none',
  color: 'text.3',
  disabledBg: 'inherit',
  disabledBoxShadow: 'none',
  disabledColor: 'disabled.2',
  height: 48,
  hoverBg: 'transparent',
  hoverBoxShadow: 'none',
  paddingX: 'xlarge',
  smallPaddingX: 'medium',
  smallHeight: 32,
  hoverText: 'text.3',
  loadingColor: 'text.3'
};
const google = { ...common,
  activeBg: 'interactive.social.google.active',
  bg: 'interactive.social.google.default',
  color: 'text.3',
  disabledBg: 'disabled.1',
  hoverBg: 'interactive.social.google.hover',
  hoverText: 'text.1'
};
const googleAlt = { ...common,
  boxShadow: [0, 0, 0, 1, 'ui4', true],
  hoverBoxShadow: [0, 0, 0, 1, 'interactive.social.google.hover', true],
  activeBg: 'interactive.social.googleAlt.active',
  color: 'text.1',
  hoverText: 'text.1',
  disabledColor: 'disabled.2',
  disabledBoxShadow: [0, 0, 0, 1, 'disabled.2', true],
  loadingColor: 'text.1'
};
const apple = { ...common,
  activeBg: 'interactive.social.apple.active',
  bg: 'interactive.social.apple.default',
  color: 'interactive.social.apple.defaultText',
  disabledBg: 'disabled.1',
  hoverBg: 'interactive.social.apple.hover',
  hoverText: 'interactive.social.apple.hoverText',
  loadingColor: 'interactive.social.apple.defaultText'
};
const size = {
  small: 12,
  large: 16
};
const theme = {
  google,
  googleAlt,
  apple,
  size
};
exports.theme = theme;
//# sourceMappingURL=ButtonSocial.theme.js.map